import t from '../translate'
import React from 'react'

export default function Expired ({}) {

  return <div className="send">
      <h3>{t('expired.title')}</h3>
      <div className="expired-section">
        <br></br>
        <p dangerouslySetInnerHTML={{ __html: t('expired.text') }}></p>
    </div>
  </div>
}
